import React from "react";
import { Link } from "react-router-dom";
import { Layout, Alert, Button } from "antd";
import { connect } from "react-redux";
import Header from "components/header";
const { Footer, Content } = Layout;

const Component = ({ location, session, component: C, ...rest }) => {
  const { pathname } = location;
  const pathArray = pathname.split("/");
  const pathKey = pathArray[1] || '/';
  const hasProfile =
    session.user.id && session.user.address && session.user.businessName;

  return (
    <Layout className="layout">
      <Header currentPath={pathKey} />
      <Content>
        <div
          style={{
            background: "#fff",
            padding: 24,
            minHeight: 280,
            flex: 1,
            width: "100%"
          }}
        >
          {!hasProfile && pathKey !== 'settings' && (
            <Alert
              showIcon
              message="Complete your profile"
              description={
                <React.Fragment>
                  <p>Please complete your profile in order to place order.</p>
                  <Link to="/settings">
                    <Button type="default">Continue</Button>
                  </Link>
                </React.Fragment>
              }
            />
          )}
          <C {...rest} location={location} />
        </div>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        ©2019-2021 FulfilledbyQprints.com All Rights Reserved
        <br />
        <a href="https://qprints.com/policies/" target="_blank">
        Qprints Terms of Use
      </a>      
        {" "}
        |{" "}
        <a
          href="https://qprints.com/privacy-policy/"
          target="_blank"
        >
          Privacy Policy
        </a>
        <br />
        The term 'Etsy' is a trademark of Etsy, Inc. This application uses the
        Etsy API but is not endorsed or certified by Etsy, Inc.
      </Footer>
    </Layout>
  );
};

const ConnectedComponent = connect(state => ({ session: state.session }))(
  Component
);

const AuthLayout = Component => {
  return props => {
    return <ConnectedComponent component={Component} {...props} />;
  };
};

export default AuthLayout;
